
/*eslint-disable */
import { useEffect, useState } from "react";

interface CityComponentProps {
    setCiudad: any
}

const CityComponent: React.FC<CityComponentProps> = ({setCiudad}) => {
  const [city, setCity] = useState(null);

  useEffect(() => {
    // Obtener la ubicación actual
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getCityName(latitude, longitude);
        },
        (error) => {
          console.error("Error al obtener la ubicación", error);
        }
      );
    }
  }, []);

  // Función para obtener el nombre de la ciudad usando la API de Geocoding
  const getCityName = (lat: any, lng: any) => {
    const apiKey = "AIzaSyBFIueHL6ufyFll26ee6TfN-qVpSvtp0sw"; // Reemplaza con tu clave de la API de Google

    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    fetch(geocodeUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.results.length > 0) {
          const addressComponents = data.results[0].address_components;
          // Filtrar para obtener la ciudad
          const cityComponent = addressComponents.find((component: any) =>
            component.types.includes("locality")
          );
          console.log(cityComponent);
          
          if (cityComponent) {
            setCity(cityComponent.long_name); // Nombre de la ciudad
            setCiudad(cityComponent.long_name); // Nombre de la ciudad
          }
        }
      })
      .catch((error) => {
        console.error("Error al obtener el nombre de la ciudad", error);
      });
  };

  return (
    <>
      {/* <div>
      <h1>Tu ciudad más cercana</h1>
      {city ? <p>La ciudad más cercana es: {city}</p> : <p>Cargando...</p>}
    </div> */}
    </>
  );
};

export default CityComponent;
